import { render, staticRenderFns } from "./PrivacyPolicies.vue?vue&type=template&id=291f847f"
import script from "./PrivacyPolicies.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports